import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=4238f120&"
import script from "./DashboardPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports